<script>
// Linha "rótulo + ajuda + v-switch" usada pelas preferências do modal Conectar
// WhatsApp (escrita, avisos automáticos). Controlada de fora: `value` é o estado
// gravado no servidor; quem ouve `change` decide otimismo e reversão.
export default {
  name: 'LinhaDeToggle',
  props: {
    rotulo: { type: String, required: true },
    ajuda: { type: String, default: '' },
    value: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    dataTest: { type: String, default: 'linha-de-toggle' },
  },
  methods: {
    aoMudar(valor) {
      this.$emit('change', Boolean(valor))
    },
  },
}
</script>

<template>
  <div
    class="d-flex align-center justify-space-between az-gap-small"
    :data-test="dataTest"
  >
    <div>
      <p class="az-text-primary az-size-14 mb-0">{{ rotulo }}</p>
      <p v-if="ajuda" class="az-text-secondary az-size-12 mb-0">{{ ajuda }}</p>
    </div>
    <v-switch
      :input-value="value"
      :disabled="disabled"
      hide-details
      dense
      class="mt-0 pt-0 flex-shrink-0"
      :data-test="`${dataTest}-toggle`"
      @change="aoMudar"
    />
  </div>
</template>
